export default {
    namespaced: true,
    state: {
        list: [
            {
                label: 'Ежемесячный',
                value: 0,
                day: '',
            },
            {
                label: 'Еженедельный',
                value: 1,
                day: '',
            },
            {
                label: 'Ежедневный',
                value: 2,
                day: '',
            },
            {
                label: 'Ежегодный',
                value: 3,
                day: '',
            },
            {
                label: 'Разовый',
                value: 4,
                day: '',
            },
        ],
        load: false,
    },
    actions:{
        get_list(){},
    },
    getters: {
        list: (state, getters, rootState, rootGetters) => {
            return state.list;
        },
    }
}